module.exports = __webpack_public_path__ + "img/zap.c92bde66.svg";